import { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { onKeyUpEnterOrSpace } from '../../../../utils';

const useStyles = makeStyles(() => ({
  root: ({ showMore, maxWidth, color }) => ({
    fontSize: '1.125rem',
    color,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: showMore ? 'normal' : 'nowrap',
    maxWidth,
  }),
}));

const EllipsisContent = ({ text, color, maxWidth = '24rem' }) => {
  const [showMore, setShowMore] = useState(false);
  const classes = useStyles({ showMore, maxWidth, color });

  const onClickHandler = () => {
    setShowMore((preState) => !preState);
  };

  return (
    <div
      className={classes.root}
      onClick={onClickHandler}
      tabIndex={0}
      onKeyUp={(e) => onKeyUpEnterOrSpace(e, onClickHandler)}
    >
      {text}
    </div>
  );
};

export default EllipsisContent;
